import React, { Component } from 'react'
import { stringify } from 'qs'
import './Form.css'

class Form extends Component {
  constructor (props) {
    super(props)
    this.state = {
      name: '',
      email: '',
      message: '',
      subject: `New Submission from ${window.location.host}!`,
      phone: '',
      _cc: 'ericjinks@gmail.com',
      disabled: false,
      alert: '',
      action: '/contact/',
      'form-name': 'Contact'
    }

    this.handleChange = this.handleChange.bind(this)
  }

  componentDidMount () {
    Array.from(document.querySelectorAll('.Form input')).forEach(i => {
      i.addEventListener('invalid', () => {
        i.dataset.touched = true
      })
      i.addEventListener('blur', () => {
        if (i.value !== '') i.dataset.touched = true
      })
    })
  }

  handleSubmit (e) {
    e.preventDefault()
    const data = {
      name: this.state.name,
      email: this.state.email,
      message: this.state.message,
      subject: this.state.subject,
      phone: this.state.phone,
      'form-name': this.state['form-name']
    }
    this.setState({ disabled: true })
    fetch(this.state.action + '?' + stringify(data), {
      method: 'POST'
    })
      .then(res => {
        if (res.ok) {
          return res
        } else {
          throw new Error('Network error')
        }
      })
      .then(res => {
        this.setState({
          disabled: false,
          alert: 'Thank you for your enquiry. I will get back to you within 24 hours. 😬',
          name: '',
          email: '',
          message: '',
          subject: `New Submission from ${window.location.host}!`,
          phone: ''
        })
      })
      .catch(err => {
        console.log(err)
        this.setState({
          disabled: false,
          alert: '❗️ There is a problem, your message has not been sent'
        })
      })
  }

  handleChange (e) {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  render () {
    return (
      <form
        name={this.state['form-name']}
        ref={(form) => { this.form = form }}
        className='Form'
        action={this.state.action}
        method='POST'
        onSubmit={e => this.handleSubmit(e)}
        data-netlify=''
        data-netlify-honeypot='phone'
      >
        { this.state.alert ? <p className='alert'>{this.state.alert}</p> : '' }
        <label className='Label'>
          <input value={this.state.name} onChange={this.handleChange} className='Input' type='text' placeholder='Your Name' name='name' required disabled={this.state.disabled ? 'disabled' : ''} />
          <svg className='Line' viewBox='0 0 40 2' preserveAspectRatio='none'>
            <path d='M0 1 L40 1' />
            <path d='M0 1 L40 1' className='focus' />
            <path d='M0 1 L40 1' className='invalid' />
            <path d='M0 1 L40 1' className='valid' />
          </svg>
        </label>
        <label className='Label'>
          <input value={this.state.email} onChange={this.handleChange} className='Input' type='email' placeholder='Your Email' name='email' required disabled={this.state.disabled ? 'disabled' : ''} />
          <svg className='Line' viewBox='0 0 40 2' preserveAspectRatio='none'>
            <path d='M0 1 L40 1' />
            <path d='M0 1 L40 1' className='focus' />
            <path d='M0 1 L40 1' className='invalid' />
            <path d='M0 1 L40 1' className='valid' />
          </svg>
        </label>
        <label className='Label'>
          <textarea value={this.state.message} onChange={this.handleChange} className='Input' placeholder='Message' name='message' rows='10' required disabled={this.state.disabled ? 'disabled' : ''} />
          <svg className='Line' viewBox='0 0 40 2' preserveAspectRatio='none'>
            <path d='M0 1 L40 1' />
            <path d='M0 1 L40 1' className='focus' />
            <path d='M0 1 L40 1' className='invalid' />
            <path d='M0 1 L40 1' className='valid' />
          </svg>
        </label>
        <input type='text' name='phone' className='form-stat' value={this.state.phone} onChange={this.handleChange} />
        <input type='hidden' name='_cc' value={this.state._cc} />
        <input type='hidden' name='subject' value={this.state.subject} />
        <input className='button' type='submit' value='Send' disabled={this.state.disabled ? 'disabled' : ''} />
      </form>
    )
  }
}

export default Form



// WEBPACK FOOTER //
// ./src/Form.js